import React from 'react';

const About = () => {
    return (
        <div className="about">
            <h1>About Us</h1>
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita, in rerum earum sunt cupiditate sapiente a fuga illum quisquam alias voluptate suscipit provident optio quas
                reiciendis placeat beatae odit vitae. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolor necessitatibus culpa, dolores atque consequuntur numquam, illo in porro enim sint.
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laudantium, quaerat similique. Hic ipsum aut iusto possimus assumenda maiores, eum ipsa, sed distinctio a cumque sunt, ducimus
                voluptatum culpa voluptates similique iure? Eos culpa libero nesciunt excepturi quos. Impedit necessitatibus iste officia sit debitis explicabo quaerat unde. Est eaque ab eligendi.
                suscipit provident tempore minus rem at dolore voluptatibus tempora sapiente?
            </p>
        </div>
    );
};

export default About;
